PJQ.collections.punchlists = {};

PJQ.models.punchlists = {};

PJQ.views.punchlists = {};

//Routes
PJQ.modules.punchList = {
	routes: [
		{
			route: 'projects/:projectId/punchlists',
			name: 'punchList',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "punchlists");
			}
		},
		{
			route: 'projects/:projectId/punchlists/:punchListItemId',
			name: 'punchListItem',
			callback: function (projectId, punchListItemId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "punchlists", {
					punchListItemId: parseInt(punchListItemId)
				});
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.punchList.routes);